import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function Layout({ title, actions, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 min-w-0">
        <Topbar title={title} actions={actions} onMenuClick={() => setSidebarOpen(true)} />
        <main className="p-4 sm:p-6" data-testid="page-content">{children}</main>
      </div>
    </div>
  );
}
